import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { List, Button, Modal, Accordion } from "antd-mobile";
import ItemInfo from "./ItemInfo";
import { Icon } from "antd";

import { FaCheckCircle, FaPlusCircle, FaAngleRight } from "react-icons/fa";
import { throttle } from "lodash";
import FoodStepper from "./FoodStepper";
import MenuDate from "./MenuDate";
import configParam from "../libs/params";
import { getDescriptionClass, getDescriptionStyles, getResponsivePriceText } from "../libs/utils";
//import PreQuestions from "./PreQuestions";
//const EXP_TRIM = /[&/\\#,+()$~%.'":*?<>{} ]/g;
const Item = List.Item;
const alert = Modal.alert;

const Menu = observer(({ cartStore, searchResult }) => {
  // Single scroll handler for all scroll events - no conflicts
  if (!window.unifiedScrollHandlerAdded) {
    window.unifiedScrollHandlerAdded = true;

  }

  // Check if there's an active search query - searchResult can be object or array
  const isSearchResultArray = Array.isArray(searchResult);
  const isSearchResultObject =
    searchResult &&
    typeof searchResult === "object" &&
    !Array.isArray(searchResult);
  // const hasSearchQuery =
  //   (isSearchResultArray && searchResult.length > 0) ||
  //   (isSearchResultObject && Object.keys(searchResult).length > 0);

  // Also check if there's an active search in the store
  // const hasActiveSearch =
  //   cartStore.menuStore.isSearchDirty ||
  //   (cartStore.menuStore.filterMenuList &&
  //     cartStore.menuStore.filterMenuList !== cartStore.menuStore.menuList);

  // const shouldShowSearchResults = hasSearchQuery || hasActiveSearch;

  // Kiểm tra xem có đang search hay không
  const searchInput = document.querySelector('input[type="search"].am-search-value');
  const hasSearchValue = searchInput && searchInput.value && searchInput.value.trim() !== "";

  // For cocolist layout (layout 4), show search results if there's a query, otherwise show all categories
  const menuToDisplay =
    cartStore.menuStore.layout === 4
      ? (hasSearchValue ? searchResult : cartStore.menuStore.menuList)
      : searchResult;



  // If search is active but only showing 1 category, force show all categories for cocolist layout
  const finalMenuToDisplay = menuToDisplay;



  // Scroll to active category for cocolist layout - using setTimeout to ensure DOM is ready
  if (cartStore.menuStore.layout === 4) {

    setTimeout(() => {
      // const activePromo = cartStore.menuStore.activePromo;
      const horizontalCategoryList = cartStore.menuStore.horizontalCategoryList;

      if (horizontalCategoryList && horizontalCategoryList[0]) {
        const activeCategoryName = horizontalCategoryList[0];
        const categoryElement = document.getElementById(activeCategoryName);

        if (categoryElement) {
          // Chỉ click submenucoco0 nếu chưa có category nào được chọn từ scroll detection
          const currentSelectedKey = cartStore.menuStore.horizontalMenuSelectedKey;
          const currentPromoKey = cartStore.menuStore.PromoMenuKey;
          
          // Kiểm tra xem có phải là lần đầu load hay không
          const isInitialLoad = !currentSelectedKey || currentSelectedKey === "";
          const hasPromoSelected = currentPromoKey !== undefined && currentPromoKey !== "";
          
          if (isInitialLoad && !hasPromoSelected && !hasSearchValue) {
          const submenucoco0 = document.getElementById("submenucoco0");
          if (submenucoco0) {
              // console.log("Clicking on submenucoco0 for initial setup");
            submenucoco0.click();
          } else {
            // console.log("submenucoco0 not found, falling back to scroll");
            categoryElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            }
          } else {
            // console.log(`Skipping submenucoco0 click - category "${currentSelectedKey}" already selected or promo "${currentPromoKey}" selected`);
          }
        }
      }
    }, 100);

    // Add scroll listener to update active menu item based on scroll position (only once)
    if (!window.cocoScrollListenerAdded) {
      window.cocoScrollListenerAdded = true;

      setTimeout(() => {
        // console.log("Adding scroll listener for cocolist layout...");
        // Try multiple possible scroll containers
        let scrollContainer = document.getElementById("menuContainer");
        if (!scrollContainer) {
          scrollContainer = document.querySelector(".ant-list-body");
        }
        if (!scrollContainer) {
          scrollContainer = document.querySelector(".scrollable-content");
        }
        if (!scrollContainer) {
          scrollContainer = document.querySelector('[style*="overflow"]');
        }
        if (!scrollContainer) {
          scrollContainer = window;
        }

        // console.log("Found scroll container:", scrollContainer);
        // console.log("Container scroll properties:", {
        //   scrollTop: scrollContainer.scrollTop || window.pageYOffset,
        //   scrollHeight:
        //     scrollContainer.scrollHeight || document.body.scrollHeight,
        //   clientHeight: scrollContainer.clientHeight || window.innerHeight,
        // });

        if (scrollContainer) {
          // console.log("Adding scroll detection to container");

          const testScroll = () => {
            // Tạm thời tắt scroll detection nếu vừa có promotion được click
            if (window.promoJustClicked) {
              // console.log("🔄 Skipping scroll detection - promotion just clicked");
              return;
            }

            // Kiểm tra xem có đang search hay không
            const searchInput = document.querySelector('input[type="search"].am-search-value');
            const hasSearchValue = searchInput && searchInput.value && searchInput.value.trim() !== "";
            
            if (hasSearchValue) {
              // console.log("🔍 Skipping scroll detection - search is active");
              return;
            }

            // const activePromo = cartStore.menuStore.activePromo;
            const horizontalCategoryList = cartStore.menuStore.horizontalCategoryList;

            // Get current scroll position
            // const currentScrollTop =
            //   scrollContainer === window
            //     ? window.pageYOffset
            //     : scrollContainer.scrollTop;

            // let minDistance = Infinity;
            let activeIndex = 0;
            // let foundElements = [];
            // let detectedCategories = [];

            // Check all category elements using ref and id
            const mainMenuContainer =
              document.querySelector(".mainMenuContainer");

            const allGridItems = mainMenuContainer
              ? mainMenuContainer.querySelectorAll(".gridItemBox.itemCatList")
              : document.querySelectorAll(".gridItemBox.itemCatList");

            // Get all actual header texts from DOM with their IDs
            const actualHeaders = [];
            allGridItems.forEach((item, idx) => {
              const header = item.querySelector(".menuHeader");
              if (header && item.id) {
                const text = header.textContent.trim();
                actualHeaders.push({
                  index: idx,
                  text: text,
                  element: item,
                  id: item.id,
                  ref: item,
                });
              }
            });
            // Use actual DOM headers as the source of truth for categories
            const categoriesToCheck = actualHeaders;

            // Logic scroll detection dựa trên chiều cao thực tế của category
            let newActiveIndex = 0;
            // const viewportHeight = window.innerHeight;
            
            // Cache để tránh detect lại cùng category
            const currentActiveCategory = cartStore.menuStore.horizontalMenuSelectedKey;

            for (let i = 0; i < categoriesToCheck.length; i++) {
              const rect = categoriesToCheck[i].element.getBoundingClientRect();
              const categoryTop = rect.top;
              // const categoryBottom = rect.bottom;
              
              // Logic dựa trên vị trí tương đối giữa các category
              let isActive = false;
              
              if (i === categoriesToCheck.length - 1) {
                // Category cuối cùng: active nếu top < 0 (đã scroll qua)
                isActive = categoryTop < 245;
              } else {
                // So sánh với category tiếp theo
                const nextRect = categoriesToCheck[i + 1].element.getBoundingClientRect();
                const nextCategoryTop = nextRect.top;
                
                // Category active nếu:
                // 1. Category hiện tại đã scroll qua (top < 0)
                // 2. VÀ category tiếp theo chưa scroll qua (nextTop >= 0)
                isActive = categoryTop < 245 && nextCategoryTop >= 245;
              }
              
              if (isActive) {
                newActiveIndex = i;
                break;
            }
            }
            
            activeIndex = newActiveIndex;
            
            // Chỉ update nếu category thực sự thay đổi
            const newActiveCategoryName = categoriesToCheck[activeIndex] ? categoriesToCheck[activeIndex].text : null;
            if (newActiveCategoryName === currentActiveCategory) {
              return; // Không cần update nếu cùng category
            }

            // Use ref to determine active category instead of distance calculation
            if (activeIndex === 0 && categoriesToCheck.length > 0) {
              // Check if we have a stored ref or selected category
              const storedRef = cartStore.menuStore.horizontalMenuSelectedKey;
              const storedIndex = cartStore.menuStore.horizontalMenuSelectedIndex;
              
              if (storedRef && storedIndex && storedIndex.length > 0) {
                // Use stored ref/index
                const refIndex = parseInt(storedIndex[0]);
                if (refIndex >= 0 && refIndex < categoriesToCheck.length) {
                  activeIndex = refIndex;
                  // const refCategory = categoriesToCheck[refIndex];
                } else {
                  // Fallback to first category
                  activeIndex = 0;
                  // const defaultCategory = categoriesToCheck[0];
// console.log(
//                    `*** FALLBACK TO DEFAULT: ${activeIndex} (${defaultCategory.text}) - ID: ${defaultCategory.element.id} ***`
//                  );
                }
              } else {
                // Use the first category as default
                // const defaultCategory = categoriesToCheck[0];
                activeIndex = 0;
// console.log(
//                   `*** DEFAULT ACTIVE: ${activeIndex} (${defaultCategory.text}) - ID: ${defaultCategory.element.id} ***`
//                 );
              }
            }

            const activeCategoryName = categoriesToCheck[activeIndex]
              ? categoriesToCheck[activeIndex].text
              : null;

            // Always update horizontalMenuSelectedIndex when scrolling
            if (activeCategoryName) {
              const currentKey =
                cartStore.menuStore.horizontalMenuSelectedKey || "";
              // const currentIndex =
              //   cartStore.menuStore.horizontalMenuSelectedIndex || [];

              // Thêm lại khai báo biến activePromo để tránh lỗi no-undef
              const activePromo = cartStore.menuStore.activePromo;

              // Logic promotion switching tối ưu - nhanh hơn
              const currentPromoName = cartStore.menuStore.promotions[activePromo];
              const currentPromoItems = cartStore.menuStore.promos[currentPromoName];
              
              // Kiểm tra nhanh xem category có thuộc promotion hiện tại không
              let categoryBelongsToCurrentPromo = false;
              let targetPromoIndex = activePromo;
              
              if (currentPromoItems) {
                categoryBelongsToCurrentPromo = currentPromoItems.some(item => 
                  item.category === activeCategoryName
                );
              }
              
              // Chỉ tìm kiếm promotion khác nếu cần thiết
              if (!categoryBelongsToCurrentPromo) {
                // Sử dụng cache để tìm kiếm nhanh
                const searchKey = `${activeCategoryName}_${activePromo}`;
                if (window.promoSearchCache && window.promoSearchCache[searchKey]) {
                  targetPromoIndex = window.promoSearchCache[searchKey];
                } else {
                  // Tìm kiếm promotion chứa category này
                  for (let i = 0; i < cartStore.menuStore.promotions.length; i++) {
                    const promoName = cartStore.menuStore.promotions[i];
                    const promoItems = cartStore.menuStore.promos[promoName];
                    
                    if (promoItems && promoItems.some(item => item.category === activeCategoryName)) {
                      targetPromoIndex = i;
                      // Cache kết quả
                      if (!window.promoSearchCache) window.promoSearchCache = {};
                      window.promoSearchCache[searchKey] = i;
                      break;
                    }
                  }
                }
                
                // Cập nhật activePromo nếu tìm thấy promotion khác
                if (targetPromoIndex !== activePromo) {
                  const targetCategoryName = activeCategoryName;
                  
                  cartStore.menuStore.activePromo = targetPromoIndex;
                  cartStore.menuStore.PromoMenuKey = targetPromoIndex;
                  cartStore.menuStore.resetMeuList();
                  
                  // Cập nhật lại horizontalCategoryList sau khi reset
                  const newHorizontalCategoryList = cartStore.menuStore.horizontalCategoryList;
                  const newCategoryIndex = newHorizontalCategoryList.indexOf(targetCategoryName);
                  
                  if (newCategoryIndex !== -1) {
                    activeIndex = newCategoryIndex;
                    cartStore.menuStore.horizontalMenuSelectedKey = targetCategoryName;
                    cartStore.menuStore.horizontalMenuSelectedIndex = [newCategoryIndex.toString()];
                  }
                }
              }

              // Update index regardless of whether key changed
              cartStore.menuStore.horizontalMenuSelectedIndex = [
                activeIndex.toString(),
              ];

              // Only update key and trigger UI changes if category actually changed
              if (currentKey !== activeCategoryName) {
// console.log(
//                   `📋 Scroll-spy mimicking side-menu click for '${activeCategoryName}' within activePromo: ${targetPromoIndex} (${cartStore.menuStore.promotions[targetPromoIndex]})`
//                 );
                // const element = document.getElementById(activeCategoryName);
                cartStore.menuStore.horizontalMenuSelectedKey =
                  activeCategoryName;

                // Update MobX store to trigger UI update
                cartStore.menuStore.horizontalMenuSelectedIndex = [
                  activeIndex.toString(),
                ];
// console.log(
//                   `🎯 Updated horizontal menu via MobX: ${activeCategoryName} is now selected at index ${activeIndex} (within promo ${targetPromoIndex})`
//                 );

                // Force reload horizontal menu by triggering a re-render
                setTimeout(() => {
                  // Try both possible menu IDs
                  const horizontalMenu =
                    document.getElementById("catgeory-horizontal") ||
                    document.getElementById("cocomunu-horizontal");
                  if (horizontalMenu) {
// console.log("🎯 Found horizontal menu:", horizontalMenu.id);

                    // Force re-render by updating a temporary property
                    cartStore.menuStore.forceMenuUpdate = Date.now();

                    // Remove all selected classes first and update text content
                    const allMenuItems =
                      horizontalMenu.querySelectorAll(".ant-menu-item");
                    allMenuItems.forEach((item, index) => {
                      item.classList.remove("ant-menu-item-selected");

                      // Update text content based on data-category attribute
                      const categoryName = item.getAttribute("data-category");
                      if (categoryName && item.textContent !== categoryName) {
                        item.textContent = categoryName;
// console.log(
//                           `📝 Updated menu item ${index}: "${categoryName}"`
//                        );
                      }
                    });

                    // Add selected class to current item
                    let currentMenuItem = horizontalMenu.querySelector(
                      `[data-category="${activeCategoryName}"]`
                    );
                    // Nếu không tìm thấy theo data-category, thử so sánh textContent (trim, lowercase)
                    if (!currentMenuItem) {
                      currentMenuItem = Array.from(allMenuItems).find(item =>
                        item.textContent.trim().toLowerCase() === activeCategoryName.trim().toLowerCase()
                      );
                    }
                    if (currentMenuItem) {
                      currentMenuItem.classList.add("ant-menu-item-selected");
                      // Scroll menu item vào giữa thanh menu ngang
                      currentMenuItem.scrollIntoView({
                        block: "nearest",
                        inline: "center",
                        behavior: "smooth"
                      });
                    } else {
                      console.warn(
                        `⚠️ Could not find menu item with data-category or textContent matching "${activeCategoryName}"`
                      );
                      // console.log(
                      //   "🔍 Available menu items:",
                      //   Array.from(allMenuItems).map((item) => ({
                      //     text: item.textContent,
                      //     dataCategory: item.getAttribute("data-category"),
                      //     id: item.id,
                      //   }))
                      // );
                    }
                  } else {
                    console.warn(
                      "⚠️ Could not find horizontal menu with ID catgeory-horizontal or cocomunu-horizontal"
                    );
                    // console.log("🔍 Available menus:", {
                    //   catgeoryHorizontal: !!document.getElementById(
                    //     "catgeory-horizontal"
                    //   ),
                    //   cocomunuHorizontal: !!document.getElementById(
                    //     "cocomunu-horizontal"
                    //   ),
                    // });
                  }
                }, 50);

                // Centre the selected <li> inside horizontal menu
                setTimeout(function () {
                  const selectedItem = document.querySelector(
                    "#cocomunu-horizontal .ant-menu-item-selected, #catgeory-horizontal .ant-menu-item-selected"
                  );
                  if (selectedItem) {
                    selectedItem.scrollIntoView({
                      block: "center",
                      inline: "center",
                      behavior: "smooth",
                    });
                  }
                }, 500);
              }
            }
          };

          // Unified scroll handler - chỉ add vào scrollContainer chính
          const unifiedScrollHandler = throttle(function () {
            testScroll();
          }, 20); // Giảm xuống 20ms để phản hồi nhanh hơn

          if (scrollContainer) {
            scrollContainer.addEventListener("scroll", unifiedScrollHandler, { passive: true });
            // console.log("✅ Added unified scroll listener to:", scrollContainer === window ? "WINDOW" : scrollContainer.tagName || scrollContainer.id);
          }

          // Immediate scroll test - chỉ chạy nếu không có search
          setTimeout(() => {
            const searchInput = document.querySelector('input[type="search"].am-search-value');
            const hasSearchValue = searchInput && searchInput.value && searchInput.value.trim() !== "";
            
            if (hasSearchValue) {
              // console.log("🔍 Skipping immediate scroll test - search is active");
              return;
            }
            
            // console.log("🧪 TESTING SCROLL DETECTION - Manual scroll now!");
            unifiedScrollHandler(); // Test immediately
          }, 500);

          // Add universal scroll detection as ultimate fallback
          let lastScrollTime = 0;
          const universalScrollHandler = function () {
            const now = Date.now();
            if (now - lastScrollTime > 10) { // Giảm xuống 10ms để phản hồi nhanh hơn
              // Throttle
              lastScrollTime = now;
              unifiedScrollHandler();
            }
          };

          // Attach to every possible scroll event
          document.addEventListener("scroll", universalScrollHandler, {
            passive: true,
            capture: true,
          });
          window.addEventListener("scroll", universalScrollHandler, {
            passive: true,
          });
          document.body.addEventListener("scroll", universalScrollHandler, {
            passive: true,
          });

          // Monitor for any new scrollable elements added to DOM
          const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
              mutation.addedNodes.forEach(function (node) {
                if (
                  node.nodeType === 1 &&
                  (node.scrollHeight > node.clientHeight ||
                    node.classList.contains("scroll"))
                ) {
                  // console.log(
                  //   "📝 Adding scroll listener to new element:",
                  //   node.tagName,
                  //   node.className
                  // );
                  node.addEventListener("scroll", universalScrollHandler, {
                    passive: true,
                  });
                }
              });
            });
          });
          observer.observe(document.body, { childList: true, subtree: true });

          // Initial test - chỉ chạy nếu không có search
          setTimeout(() => {
            const searchInput = document.querySelector('input[type="search"].am-search-value');
            const hasSearchValue = searchInput && searchInput.value && searchInput.value.trim() !== "";
            
            if (!hasSearchValue) {
              testScroll();
            } else {
              // console.log("🔍 Skipping initial scroll test - search is active");
            }
          }, 100);
          // console.log(
          //   "Scroll listener added successfully to:",
          //   scrollContainer === window
          //     ? "WINDOW"
          //     : scrollContainer.tagName || scrollContainer.id
          // );

          // Test scroll detection after a delay - chỉ chạy nếu không có search
          setTimeout(function () {
            const searchInput = document.querySelector('input[type="search"].am-search-value');
            const hasSearchValue = searchInput && searchInput.value && searchInput.value.trim() !== "";
            
            if (hasSearchValue) {
              // console.log("🔍 Skipping scroll detection test - search is active");
              return;
            }
            
            // console.log("🧪 Testing scroll detection after 2 seconds...");
            // const testScrollPos =
            //   scrollContainer === window
            //     ? window.pageYOffset
            //     : scrollContainer.scrollTop;
            // console.log("Current scroll position:", testScrollPos);
            // console.log(
            //   "Scroll container type:",
            //   scrollContainer === window ? "WINDOW" : scrollContainer.tagName
            // );

            // Try to scroll a bit to test detection
            if (scrollContainer === window) {
              // console.log(
              //   "📜 Try scrolling the page manually to test detection"
              // );
            } else {
              // console.log(
              //   "📜 Try scrolling the container manually to test detection"
              // );
            }
          }, 2000);
        }
      }, 800);
    }
  }
  if (cartStore.menuStore.isLoading) {
    return (
      <div className="loadingDiv">
        <p>Loading...</p>
        <img
          src="https://www.foodzaps.com/public/img/ppp_loading.gif"
          alt="loading..."
        />
      </div>
    );
  } else {
    //// console.log(cartStore.menuStore.activePromo,'yy');
    const paymentRes = localStorage.getItem("hideMenu");
    //localStorage.removeItem('hideMenu');

    let claName =
      "menuContainer fixedMenuSection" +
      (cartStore.menuStore.menu_type === "0" ? " fixedMenuImage" : "");
    if (cartStore.menuStore.menu_type === "1") {
      //// console.log('first');
      if (paymentRes) {
        //// console.log('second');
        claName = "menuContainer popupMenu toggleMenuCls";
        //localStorage.removeItem('hideMenu');
      } else {
        claName = "menuContainer popupMenu";
      }
    }

    return (
      <div className={claName} id="menuContainer">
        <div className="sideMenuContainer">
          <div
            className={
              paymentRes ? "smallIconArrow hideshowArrow" : "smallIconArrow"
            }
            id="smallIconArrow"
            onClick={() => {
              if (cartStore.menuStore.menu_type === "1") {
                document
                  .getElementById("menuContainer")
                  .classList.toggle("toggleMenuCls");
              }
            }}
          >
            {" "}
            <FaAngleRight />
          </div>
          {cartStore.menuStore.promotions.length > 0 &&
          cartStore.menuStore.promotions[0] !== "" ? (
            <Accordion
              accordion
              openAnimation={{}}
              defaultActiveKey={
                cartStore.menuStore.promotions.length === 1 ? "0" : ""
              }
              className="my-accordion"
              onChange={(key) => {
                if (key === undefined) {
                  return false;
                }
                if (cartStore.menuStore.menu_type === "1") {
                  document
                    .getElementById("menuContainer")
                    .classList.toggle("toggleMenuCls");
                }
                cartStore.menuStore.horizontalMenuSelectedKey = key;
                cartStore.menuStore.activePromo = key;
                cartStore.menuStore.resetMeuList();
                cartStore.menuStore.searchResult =
                  cartStore.menuStore.filterMenuList;
              }}
            >
              {cartStore.menuStore.promotions.map((item, index) => (
                <Accordion.Panel
                  header={item}
                  key={index}
                  id={"menutest-" + index}
                  className={"menutest-" + index}
                  style={{ cursor: "pointer" }}
                >
                  <List className="my-list">
                    {cartStore.menuStore
                      .getCategories(item)
                      .map((cat, indexca) => (
                        <SideMenuEntry
                          item={cat}
                          menuStore={cartStore.menuStore}
                          key={`promo${index}${indexca}`}
                        />
                      ))}
                  </List>
                </Accordion.Panel>
              ))}
            </Accordion>
          ) : (
            <List className="sideMenu">
              {cartStore.menuStore.categories.map((item, index) => (
                <SideMenuEntry
                  item={item}
                  menuStore={cartStore.menuStore}
                  key={`side${index}`}
                />
              ))}
              <Item className="sizeMenuItem extraEmpty">&nbsp;</Item>
            </List>
          )}
        </div>

        <div
          className={
            cartStore.menuStore.layout === 2
              ? "mainMenuContainer gridcirclebgwhte"
              : "mainMenuContainer"
          }
          //onLoad={(k)=>{document.getElementsByClassName('mainMenuContainer').addEventListener("scroll");}}
          onScroll={(el) => {
            let pos = 95;
            if (cartStore.menuStore.menu_type === "2") {
              pos = 115;
            } else if (cartStore.menuStore.layout === 4) {
              pos = 290;
            } else if (cartStore.menuStore.flashHeaderMsg.length > 0) {
              pos = pos + 15 + 15 * cartStore.menuStore.flashHeaderMsg.length;
            }
            // else if(cartStore.menuStore.layout===4)
            // {
            // pos = 1500;
            // }
            //// console.log(pos);
            let d = document.elementFromPoint(0, pos);
            //   // console.log(d);
            if (
              d.firstChild === null ||
              d.firstChild === undefined ||
              d.firstChild.attributes === undefined ||
              d.firstChild.attributes.length === 0
            ) {
              return;
            }

            let firstChTop = d.firstChild.getBoundingClientRect().top;
            let diffTopback = d.offsetHeight + firstChTop;
            let allT = d.attributes;
            if (!allT || allT.length === 0 || !allT[0]) {
              return;
            }
            let valT = allT[0].value;
            //// console.log(valT,pos);
            if (cartStore.menuStore.layout === 4) {
              if (allT[0].name === "id") {
                //// console.log(valT,'jkkk');
                let data = cartStore.menuStore.horizontalCategoryList;
                let ind = data.indexOf(valT);
                if (ind > -1) {
                  cartStore.menuStore.horizontalMenuSelectedIndex = [
                    ind.toString(),
                  ];
                  const el = document.getElementById("submenucoco" + ind);
                  if (el) {
                    el.scrollIntoView();
                  }
                }
                // console.log(valT,ind);
              }
            } else {
              let totalDiff = 400;
              let diffTop = 80;

              if (cartStore.menuStore.flashHeaderMsg.length > 0) {
                diffTop = 120;
              }
              // if(cartStore.menuStore.layout===4)
              // {
              // diffTop=400;
              // totalDiff=600;
              // }
              if (
                d.attributes.length > 0 &&
                (firstChTop > diffTop ||
                  (diffTopback > totalDiff &&
                    cartStore.menuStore.horizontalMenuClickedKey === ""))
              ) {
                if (allT[0].name === "id") {
                  var x = document.getElementById("hitem-" + valT);
                  if (x) {
                    x = x.parentElement;
                  }
                  cartStore.menuStore.resetCocoMenu(valT);
                  if (
                    x !== null &&
                    x !== undefined &&
                    (cartStore.menuStore.horizontalMenuClickedKey === valT ||
                      cartStore.menuStore.horizontalMenuClickedKey === "")
                  ) {
                    cartStore.menuStore.horizontalMenuClickedKey = "";
                    let cElement = document.getElementsByClassName("active");
                    //// console.log(cElement,'app');
                    if (cElement.length > 0) {
                      // console.log(cElement);
                      while (cElement.length > 0) {
                        cElement[0].classList.remove("active");
                      }
                    }
                    x.classList.add("active");
                    x.scrollIntoView(true);
                  }
                }
              }

              let allCats = document.querySelectorAll(".itemCatList");
              if (allCats.length > 0) {
                //let fDiv=allCats[0].attributes;
                let lDivElement = allCats[allCats.length - 2];
                if (lDivElement) {
                  let lDiv = lDivElement.attributes;

                  let lastElement = allCats[allCats.length - 1];
                  if (lastElement) {
                    let lastDiv = lastElement.attributes;
                    //// console.log(diffTopback);
                    if (
                      lastDiv && lastDiv.length > 0 && lastDiv[0] &&
                      lDiv && lDiv.length > 0 && lDiv[0] &&
                      cartStore.menuStore.horizontalMenuClickedKey ===
                        lastDiv[0].value &&
                      !lDivElement.classList.contains("active") &&
                      diffTopback > 300 &&
                      diffTopback < 400 &&
                      lDiv[0].value === valT
                    ) {
                      cartStore.menuStore.horizontalMenuClickedKey = "";
                    }
                  }
                }
              }
            }
          }}
        >
          <MenuDate mdateTime={cartStore.menuStore.getMenuDateTime()} />
          {Object.keys(finalMenuToDisplay).map((key, index) => {
            return (
              <MenuEntry
                header={key}
                items={finalMenuToDisplay[key]}
                cartStore={cartStore}
                categoryIndex={index}
                key={`entry${index}`}
              />
            );
          })}
          {cartStore.menuStore.isKopikingControler() && (
            <div className="fkopi" style={{ marginTop: "10px" }}>
              <div className="flinks">
                <a
                  href="/term-conditions.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cartStore.menuStore.translation.term_condition}{" "}
                </a>
                <a
                  href="/privacy-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cartStore.menuStore.translation.privacy_policy}{" "}
                </a>
                <a
                  href="/return-policy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {cartStore.menuStore.translation.return_policy}{" "}
                </a>
                <a href="/faq.html" target="_blank" rel="noopener noreferrer">
                  {cartStore.menuStore.translation.faq}{" "}
                </a>
              </div>
            </div>
          )}
        </div>

        <ItemInfo visible={cartStore.menuStore.itemModal.isVisible} />
        <Modal
          visible={cartStore.menuStore.itemModal.multiCheckBox}
          transparent={true}
          maskClosable={false}
          animationType="slide-up"
          title={
            cartStore.menuStore.itemModal.isMenuPopup
              ? cartStore.menuStore.itemModal.item_popup_name
              : cartStore.menuStore.translation.opt_selection_title
          }
          className={
            cartStore.menuStore.itemModal.isMenuPopup
              ? "App table_question spacebottom"
              : "App table_question"
          }
          closable={cartStore.menuStore.itemModal.isMenuPopup}
          onClose={() => {
            //  // console.log(555);
            cartStore.menuStore.itemModal.multiCheckBox = false;
          }}
          footer={cartStore.menuStore.itemModal.footerBtn}
        >
          <div className="row borderTop">
            {cartStore.menuStore.itemModal.checkboxOptions}
          </div>
        </Modal>
      </div>
    );
  }
});

const MenuEntry = observer(({ header, items, cartStore, categoryIndex }) => {
  //<CocoListEntry key={index} item={item} cartStore={cartStore} />
  if (cartStore.menuStore.layout === 4) {
    return (
      <div 
        id={header} 
        className="gridItemBox itemCatList"
        data-category-index={categoryIndex}
      >
        <div className="menuHeader">{header}</div>
        <section className={"gridContainer listvw"}>
          {items.filter((item) => {
            return cartStore.menuStore.isAvailable(item);
          }).map((item, index) => (
            <div className="menuItemsFlex" key={index + "-cocl"}>
              <CocoListEntry key={index} item={item} cartStore={cartStore} />
            </div>
          ))}
        </section>
      </div>
    );
  } else if (cartStore.menuStore.layout === 0) {
    return (
      <div 
        id={header} 
        style={{ padding: 6 }} 
        className="itemCatList"
        data-category-index={categoryIndex}
      >
        <div className="menuHeader">{header}</div>
        {items.map((item, index) => (
          <ListEntry key={index} item={item} cartStore={cartStore} />
        ))}
      </div>
    );
  } else if (cartStore.menuStore.layout === 3) {
    return (
      <div 
        id={header} 
        style={{ padding: 6 }} 
        className="itemCatList"
        data-category-index={categoryIndex}
      >
        <div className="menuHeader">{header}</div>
        {items.map((item, index) => (
          <ListLightEntry key={index} item={item} cartStore={cartStore} />
        ))}
      </div>
    );
  } else {
    return (
      <div 
        id={header} 
        className="gridItemBox itemCatList"
        data-category-index={categoryIndex}
      >
        <div className="menuHeader">{header}</div>
        <section
          className={
            cartStore.menuStore.layout === 2
              ? "gridContainer listvw newGridtheme"
              : "gridContainer listvw"
          }
        >
          {items.map((item, index) => (
            <GridEntry key={index} item={item} cartStore={cartStore} />
          ))}
        </section>
      </div>
    );
  }
});
const GridEntry = observer(({ item, cartStore }) => {
  let avail = cartStore.menuStore.isAvailable(item);
  let priceTx =
    parseFloat(item.price) === 0
      ? cartStore.menuStore.translation.price_zero
      : item.displayPrice;
  let infoItem = item.name.includes("#INFO#");
  let name = item.name.replace("#INFO#", "");
  let infoClass = "";
  // let bgwhite="";
  // let link1="";
  let link = "";

  const chef1 = item.chef1 || 0;

  if (infoItem) {
    infoClass = "infoItem";
    let regex = /href\s*=\s*(['"])(https?:\/\/.+?)\1/gi;
    let links = [];
    name.replace(regex, function (url) {
      links.push(url);
      return url;
    });
    if (links.length > 0) {
      link = links[links.length - 1];
      link = link.replace("href=", "");
      link = link.replace(/["']/g, "");
      //link=link.replace("'","");
    }
    //// console.log(link);
  }
  let qty = cartStore.quantity_map.get(item.id);
  name = _appendQty(qty, name);
  let btnCls = "gridItemButton";
  if (cartStore.menuStore.layout === 2) {
    btnCls += " break-new-theme-btn";
  }
  if (qty > 0) {
    btnCls += " qtyc";
  }
  return (
    <div
      className={
        item.promoName.replace(/ /g, "-").toLowerCase() +
        " itemslist gridItem " +
        infoClass
      }
      id={item.id}
    >
      <div className={infoItem ? "imgdv gridcircle" : "gridcircle"}>
        {chef1 === 1 ? <span className="chefRecommended"></span> : null}
        <div className="thumbnailPlaceholder" />
        <img
          className="gridEntryImage imageLoaded"
          src={item.thumbnail}
          alt=""
          onClick={() => {
            //// console.log(88);
            if (item.isInStock && avail && !infoItem) {
              //cartStore.menuStore.itemModal.setItem(item);
              manageItemInfo(item, cartStore);
            } else if (infoItem && link !== "") {
              // window.gtag('event', 'CLICK', { 'event_category': 'URL', 'event_label': link, 'value': 1 });
              cartStore.menuStore.sendGoogleAnalytics("URL", "CLICK", link, 1);
              window.open(link, "_blank");
            }
          }}
        />
      </div>
      <div
        style={{ padding: 6 }}
        className={infoItem ? "cont mobilepadding" : "mobilepadding"}
      >
        <span
          className="itemPrice"
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(priceTx),
          }}
        />
        <br />
        <span
          className="max-lines"
          style={{ minHeight: "2.8em" }}
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(name),
          }}
          onClick={() => {
            if (infoItem && link !== "") {
              //  window.gtag('event', 'CLICK', { 'event_category': 'URL', 'event_label': link, 'value': 1 });
              cartStore.menuStore.sendGoogleAnalytics("URL", "CLICK", link, 1);
              //window.open(link,'_blank');
            }
          }}
        />
        {infoItem ? (
          <span
            className="max-lines"
            style={{ minHeight: "2.8em" }}
            dangerouslySetInnerHTML={{
              __html: cartStore.menuStore.htmlDecode(item.description),
            }}
          />
        ) : null}
      </div>
      {item.isInStock && avail && !infoItem ? (
        <Button
          size={cartStore.menuStore.layout === 2 ? "large" : "small"}
          icon={qty > 0 ? <FaCheckCircle color={"green"} /> : <FaPlusCircle />}
          className={btnCls}
          onClick={() => {
            // cartStore.menuStore.itemModal.setItem(item);
            //// console.log(5);
            specialRequest(cartStore, item, 1, 1);
          }}
        >
          {cartStore.menuStore.translation.cart}
        </Button>
      ) : null}

      {!avail ? (
        <Button
          className="gridItemButton"
          size="small"
          style={{ color: "gray" }}
          disabled
        >
          {cartStore.menuStore.translation.not_available}
        </Button>
      ) : null}
      {!item.isInStock && !infoItem ? (
        <Button
          className="gridItemButton"
          size="small"
          style={{ color: "gray" }}
          disabled
        >
          {cartStore.menuStore.translation.out_of_stock}
        </Button>
      ) : null}
    </div>
  );
});

const ListEntry = observer(({ item, cartStore }) => {
  let avail = cartStore.menuStore.isAvailable(item);
  let priceTx =
    parseFloat(item.price) === 0
      ? cartStore.menuStore.translation.price_zero
      : item.displayPrice;
  let infoItem = item.name.includes("#INFO#", "");
  let name = item.name.replace("#INFO#", "");

  const chef1 = item.chef1 || 0;

  return (
    <div
      style={{
        display: "flex",
        paddingBottom: 15,
        position: "relative",
        width: "100%",
      }}
      className={item.promoName.replace(/ /g, "-").toLowerCase() + " itemslist"}
      key={item.id}
      id={item.id}
    >
      <div
        style={{
          paddingRight: 6,
          position: "relative",
        }}
        onClick={() => {
          if (item.isInStock && avail) {
            //cartStore.menuStore.itemModal.setItem(item);
            manageItemInfo(item, cartStore);
          }
        }}
        className="customList"
      >
        {chef1 === 1 ? <span className="chefRecommended"></span> : null}
        <div className="thumbnailPlaceholder" />
        <img
          className="listEntryImage imageLoaded"
          src={item.thumbnail}
          alt=""
        />
      </div>

      <div className="li-text" style={{ paddingLeft: "15px" }}>
        <h4
          className="li-head max-lines"
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(name),
          }}
        />
        <p className="li-sub" style={{ paddingTop: 3 }}>
          <span
            className="itemPrice"
            dangerouslySetInnerHTML={{
              __html: cartStore.menuStore.htmlDecode(priceTx),
            }}
          />

          {!item.isInStock && (
            <span
              style={{
                display: "block",
                color: "gray",
                fontSize: 12,
                paddingTop: 9,
                width: 138,
                textAlign: "center",
              }}
            >
              {cartStore.menuStore.translation.out_of_stock}
            </span>
          )}
          {!avail && (
            <span
              style={{
                display: "block",
                color: "gray",
                fontSize: 12,
                paddingTop: 9,
                width: 138,
                textAlign: "center",
              }}
            >
              {cartStore.menuStore.translation.not_available}
            </span>
          )}
        </p>

        {item.isInStock && avail && !infoItem ? (
          <div>
            <FoodStepper
              value={
                cartStore.quantity_map.get(item.id)
                  ? cartStore.quantity_map.get(item.id)
                  : 0
              }
              min={0}
              onChange={throttle(
                (quantity) => {
                  /* if (item.hasAddons) {
                     cartStore.menuStore.itemModal.setItem(item);
                   } else {
                       cartStore.addItemFromMenu(item, quantity);
           cartStore.menuStore.sendGoogleAnalytics(cartStore.menuStore.googleAddItem,item.name,cartStore.menuStore.controller,item.price*quantity);
                   }*/
                  // console.log(quantity);
                  specialRequest(cartStore, item, -quantity, 0);
                },
                250,
                { maxWait: 1000 }
              )}
              disabled={item.isInStock ? false : true}
              screen="menuscreen"
              checkQuanityError={checkQuanityError}
              cartStore={cartStore}
              item={item}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
});
const CocoListEntry = observer(({ item, cartStore }) => {
  let avail = cartStore.menuStore.isAvailable(item);
  let amt = 0;
  if (item.hasAddons) {
    amt = cartStore.getLeastAddonPrice([item.addons]);
  }

  // Standard price text (without any prefix yet)
  const baseStandard =
    parseFloat(item.price) === 0
      ? `From ${cartStore.menuStore.currencySymbol}${parseFloat(amt).toFixed(
          2
        )}`
      : item.displayPrice;

  // Do we have a membership price?
  const hasMembership = !!item.membershipPrice;

  // Final string you'll render for the regular price
  const standardPriceText = hasMembership
    ? `Standard: ${baseStandard}`
    : baseStandard;

  // Optional membership text
  const membershipPriceText = hasMembership
    ? `Member: ${cartStore.menuStore.currencySymbol} ${parseFloat(
        item.membershipPrice.price
      ).toFixed(2)}`
    : null;

  let infoItem = item.name.includes("#INFO#");
  let name = item.name.replace("#INFO#", "");
  let qty = 0;
  if (cartStore.cartQty > 0) {
    qty = cartStore.getItemQty(item);
  }
  const chef1 = item.chef1 || 0;
  let parentCls =
    item.promoName.replace(/ /g, "-").toLowerCase() + " itemslist";
  if (chef1 === 1) {
    parentCls += " parentChef";
  }
  return (
    <div
      style={{
        display: "flex",
        paddingBottom: 15,
        position: "relative",
        width: "100%",
      }}
      className={parentCls}
      key={item.id}
      id={item.id}
    >
      <div
        style={{
          paddingRight: 6,
          position: "relative",
        }}
        onClick={() => {
          if (item.isInStock && avail) {
            manageItemInfo(item, cartStore);
          }
        }}
        className="customList"
      >
        {chef1 === 1 ? <span className="chefRecommended"></span> : null}
        <div className="thumbnailPlaceholder" />
        <img
          className="listEntryImage imageLoaded"
          src={item.thumbnail}
          alt=""
        />
      </div>

      <div className="li-text" style={{ paddingLeft: "15px" }}>
        <h4
          className="li-head max-lines"
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(name),
          }}
        />
        <div
          className={getDescriptionClass(item.description, 150)}
          style={getDescriptionStyles(item.description, 150)}
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(item.description),
          }}
        />
        <div className="priceDetails">
          <p className="li-sub" style={{ paddingTop: 3 }}>
            <span
              className="itemPrice standard-price"
              dangerouslySetInnerHTML={{
                __html: cartStore.menuStore.htmlDecode(getResponsivePriceText(standardPriceText, 'standard')),
              }}
            />
            {hasMembership && (
              <>
                <br />
                <span
                  className="itemPrice membership-price"
                  style={{ color: "#ff6b00" }}
                  dangerouslySetInnerHTML={{
                    __html: cartStore.menuStore.htmlDecode(getResponsivePriceText(membershipPriceText, 'membership')),
                  }}
                />
              </>
            )}
          </p>
          {!item.isInStock && (
            <div>
              <span
                style={{
                  display: "block",
                  color: "gray",
                  fontSize: 12,
                  paddingTop: 9,
                  width: 138,
                  textAlign: "center",
                }}
              >
                {cartStore.menuStore.translation.out_of_stock}
              </span>
            </div>
          )}
          {!avail && item.isInStock && (
            <div>
              <span
                style={{
                  display: "block",
                  color: "gray",
                  fontSize: 12,
                  paddingTop: 9,
                  width: 138,
                  textAlign: "center",
                }}
              >
                {cartStore.menuStore.translation.not_available_now}
              </span>
            </div>
          )}
          {item.isInStock && avail && !infoItem && (
            <div>
              {qty > 0 ? (
                <FoodStepper
                  value={qty}
                  min={0}
                  onChange={throttle(
                    (quantity) => {
                      if (!item.hasAddons) {
                        // Không có addon, cập nhật đúng số lượng
                        const delta = quantity - qty;
// console.log('[DEBUG] Item:', item.name, '| Old qty:', qty, '| New qty:', quantity, '| Delta:', delta);
                        if (delta !== 0) {
                          if (delta > 0) {
                            // Tăng số lượng: gọi addItemFromMenu với số lượng mới (tổng)
                            cartStore.addItemFromMenu(item, quantity);
                          } else if (delta < 0) {
                            // Giảm số lượng: gọi addItemFromMenu với số lượng mới (tổng)
                            cartStore.addItemFromMenu(item, quantity);
                          }
                          // Log sau khi cập nhật số lượng thực tế
                          // setTimeout(() => {
                          //   const newQty = cartStore.quantity_map.get(item.id);
                          //   console.log('[DEBUG] Item:', item.name, '| Old qty:', qty, '| New qty:', quantity, '| Delta:', delta, '| Actual qty after update:', newQty);
                          // }, 100);
                        }
                      } else {
                        // Có addon, mở popup như cũ
                      specialRequest(cartStore, item, -quantity, 0);
                      }
                    },
                    250,
                    { maxWait: 1000 }
                  )}
                  disabled={item.isInStock ? false : true}
                  screen="menuscreen"
                  checkQuanityError={checkQuanityError}
                  cartStore={cartStore}
                  item={item}
                />
              ) : (
                <div>
                  <div className={"food-stepper-container single"}>
                    <span
                      onClick={() => {
                        if (!item.hasAddons) {
                          // Tăng từ 0 lên 1
                          cartStore.addItemFromMenu(item, 1);
                        } else {
                        specialRequest(cartStore, item, 1, 1);
                        }
                      }}
                      className="food-stepper-select plus"
                    >
                      <Icon
                        type="plus"
                        style={{ width: "15px", height: "15px" }}
                      />
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

const ListLightEntry = observer(({ item, cartStore }) => {
  let avail = cartStore.menuStore.isAvailable(item);
  let priceTx =
    parseFloat(item.price) === 0
      ? cartStore.menuStore.translation.price_zero
      : item.displayPrice;
  if (!priceTx || priceTx.trim() === "") {
    priceTx = "&nbsp;";
  }

  let infoItem = item.name.includes("#INFO#");
  let name = item.name.replace("#INFO#", "");
  let defaultImage = item.thumbnail.includes("/dish");

  const chef1 = item.chef1 || 0;

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        width: "100%",
      }}
      className={
        item.promoName.replace(/ /g, "-").toLowerCase() +
        " itemslist thinnercls"
      }
      key={item.id}
      id={item.id}
    >
      {!defaultImage ? (
        <div
          style={{
            paddingRight: 6,
            position: "relative",
          }}
          onClick={() => {
            if (item.isInStock && avail) {
              //cartStore.menuStore.itemModal.setItem(item);
              manageItemInfo(item, cartStore);
            }
          }}
          className="customList"
        >
          {chef1 === 1 ? <span class="chefRecommended"></span> : null}
          <div className="thumbnailPlaceholder" />
          <img
            className="listEntryImage imageLoaded"
            src={item.thumbnail}
            alt=""
          />
        </div>
      ) : (
        ""
      )}

      <div
        className={
          defaultImage ? "li-text paddingleft0" : "li-text paddingleft15"
        }
      >
        <h4
          className="li-head max-lines"
          dangerouslySetInnerHTML={{
            __html: cartStore.menuStore.htmlDecode(name),
          }}
          onClick={() => {
            if (item.isInStock && avail) {
              //cartStore.menuStore.itemModal.setItem(item);
              manageItemInfo(item, cartStore);
            }
          }}
        />
        <p className="li-sub" style={{ paddingTop: 3 }}>
          <span
            className="itemPrice"
            dangerouslySetInnerHTML={{
              __html: cartStore.menuStore.htmlDecode(priceTx),
            }}
            onClick={() => {
              if (item.isInStock && avail) {
                //cartStore.menuStore.itemModal.setItem(item);
                manageItemInfo(item, cartStore);
              }
            }}
          />
          asdasdsads21321
          {!item.isInStock && (
            <span
              style={{
                display: "block",
                color: "gray",
                fontSize: 12,
                paddingTop: 9,
                width: 138,
                textAlign: "center",
              }}
            >
              {cartStore.menuStore.translation.out_of_stock}
            </span>
          )}
          {!avail && (
            <span
              style={{
                display: "block",
                color: "gray",
                fontSize: 12,
                paddingTop: 9,
                width: 138,
                textAlign: "center",
              }}
            >
              {cartStore.menuStore.translation.not_available}
            </span>
          )}
        </p>

        {item.isInStock && avail && !infoItem ? (
          <div
            className={
              defaultImage ? "defaultimgRight rightstepper" : "rightstepper"
            }
          >
            <FoodStepper
              value={
                cartStore.quantity_map.get(item.id)
                  ? cartStore.quantity_map.get(item.id)
                  : 0
              }
              min={0}
              onChange={throttle(
                (quantity) => {
                  /* if (item.hasAddons) {
                     cartStore.menuStore.itemModal.setItem(item);
                   } else {
                     cartStore.addItemFromMenu(item, quantity);
                       cartStore.menuStore.sendGoogleAnalytics(cartStore.menuStore.googleAddItem,item.name,cartStore.menuStore.controller,item.price*quantity);
                   }*/
                  specialRequest(cartStore, item, -quantity, 0);
                },
                250,
                { maxWait: 1000 }
              )}
              disabled={item.isInStock ? false : true}
              screen="menuscreen"
              checkQuanityError={checkQuanityError}
              cartStore={cartStore}
              item={item}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
});
const SideMenuEntry = ({ item, menuStore }) => (
  <Item
    wrap={true}
    multipleLine={true}
    className="sizeMenuItem"
    onClick={() => {
      if (menuStore.menu_type === "1") {
        document
          .getElementById("menuContainer")
          .classList.toggle("toggleMenuCls");
      }
      //document.getElementById("menuContainer").classList.toggle('toggleMenuCls');
      if (menuStore.isSearchDirty) {
        menuStore.resetMenu().then(() => {
          if (menuStore.isAnimation === 1) {
            document
              .getElementById(item)
              .scrollIntoView({
                block: "start",
                inline: "nearest",
                behavior: "smooth",
              });
          } else {
            document
              .getElementById(item)
              .scrollIntoView({ block: "start", inline: "nearest" });
          }
        });
      } else {
        if (menuStore.isAnimation === 1) {
          document
            .getElementById(item)
            .scrollIntoView({
              block: "start",
              inline: "nearest",
              behavior: "smooth",
            });
        } else {
          document
            .getElementById(item)
            .scrollIntoView({ block: "start", inline: "nearest" });
        }
      }
    }}
  >
    {item}
  </Item>
);
const RewardList = observer(({ visible, cartStore, onCloseFunction }) => {
  const userInfo = cartStore.menuStore.social || {};
  // const rewards = userInfo.campaignBalances || [];

  return (
    <Modal
      placement="left"
      onClose={onCloseFunction}
      className="profileDrawer"
      closable={false}
      visible={visible}
    >
      <div className="profileScreen">
        {/* Header */}
        <div className="info_header" style={{ padding: "20px 20px 10px 20px" }}>
          <span
            className="backBtn"
            onClick={() => {
              onCloseFunction();
            }}
          ></span>
          <span className="logoclass">
            <img
              src={cartStore.menuStore.getLogo()}
              alt="logo"
              style={{ height: "60px" }}
            />
          </span>
          <span className="homeclass"></span>
        </div>

        {/* User Name */}
        <div className="profileUserName">
          {userInfo.firstName || ""} {userInfo.lastName || ""}
        </div>

        {/* Tier Badge */}
        <div className="profileTierBadge h7 w-fit h-6 center py-2 px-3 rounded-[4px]">
          <span>
            {userInfo.membership &&
            userInfo.membership[0] &&
            userInfo.membership[0].membershipTagName
              ? `${userInfo.membership[0].membershipTagName} Tier`
              : ""}
          </span>
        </div>

        {/* Customer Info */}
        <div className="profileCustomerInfo">
          <h3>Customer Info</h3>

          <div className="profileInfoRow">
            <div className="profileInfoIcon">
              <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.73972 4C4.33119 4 4 4.33118 4 4.73973C4 8.17572 5.03371 11.0114 7.01118 12.9888C8.98865 14.9664 11.8243 16 15.2603 16C15.6688 16 16 15.6688 16 15.2603V15.2551V15.25V15.2449V15.2398V15.2346V15.2295V15.2244V15.2191V15.214V15.2089V15.2038V15.1986V15.1935V15.1884V15.1832V15.1781V15.173V15.1679V15.1627V15.1575V15.1524V15.1472V15.1421V15.137V15.1319V15.1267V15.1216V15.1165V15.1113V15.1062V15.1011V15.0959V15.0907V15.0856V15.0805V15.0753V15.0702V15.0651V15.06V15.0548V15.0497V15.0446V15.0394V15.0342V15.0291V15.024V15.0188V15.0137V15.0086V15.0034V14.9983V14.9932V14.9881V14.9829V14.9778V14.9726V14.9674V14.9623V14.9572V14.9521V14.9469V14.9418V14.9367V14.9315V14.9264V14.9213V14.9162V14.9109V14.9058V14.9007V14.8955V14.8904V14.8853V14.8802V14.875V14.8699V14.8648V14.8596V14.8545V14.8493V14.8442V14.839V14.8339V14.8288V14.8236V14.8185V14.8134V14.8083V14.8031V14.798V14.7929V14.7876V14.7825V14.7774V14.7723V14.7671V14.762V14.7569V14.7517V14.7466V14.7415V14.7363V14.7312V14.726V14.7209V14.7157V14.7106V14.7055V14.7003V14.6952V14.6901V14.685V14.6798V14.6747V14.6696V14.6643V14.6592V14.6541V14.649V14.6438V14.6387V14.6336V14.6284V14.6233V14.6182V14.6131V14.6079V14.6027V14.5976V14.5924V14.5873V14.5822V14.5771V14.5719V14.5668V14.5617V14.5565V14.5514V14.5463V14.5411V14.5359V14.5308V14.5257V14.5205V14.5154V14.5103V14.5052V14.5V14.4949V14.4898V14.4846V14.4794V14.4743V14.4692V14.464V14.4589V14.4538V14.4486V14.4435V14.4384V14.4333V14.4281V14.423V14.4178V14.4126V14.4075V14.4024V14.3973V14.3921V14.387V14.3819V14.3767V14.3716V14.3665V14.3614V14.3561V14.351V14.3459V14.3407V14.3356V14.3305V14.3254V14.3202V14.3151V14.31V14.3048V14.2997V14.2945V14.2894V14.2842V14.2791V14.274V14.2688V14.2637V14.2586V14.2535V14.2483V14.2432V14.2381V14.2328V14.2277V14.2226V14.2175V14.2123V14.2072V14.2021V14.1969V14.1918V14.1867V14.1816V14.1764V14.1712V14.1661V14.1609V14.1558V14.1507V14.1456V14.1404V14.1353V14.1302V14.125V14.1199V14.1148V14.1096V14.1044V14.0993V14.0942V14.089V14.0839V14.0788V14.0737V14.0685V14.0634V14.0583V14.0531V14.0479V14.0428V14.0377V14.0325V14.0274V14.0223V14.0171V14.012V14.0069V14.0018V13.9966V13.9915V13.9863V13.9811V13.976V13.9709V13.9658V13.9606V13.9555V13.9504V13.9452V13.9401V13.935V13.9298V13.9246V13.9195V13.9144V13.9092V13.9041V13.899V13.8938V13.8887V13.8836V13.8785V13.8733V13.8682V13.863V13.8578V13.8527V13.8476V13.8425V13.8373V13.8322V13.8271V13.8219V13.8168V13.8117V13.8066V13.8013V13.7962V13.7911V13.7859V13.7808V13.7757V13.7706V13.7654V13.7603V13.7552V13.75V13.7449V13.7397V13.7346V13.7294V13.7243V13.7192V13.714V13.7089V13.7038V13.6987V13.6935V13.6884V13.6833V13.678V13.6729V13.6678V13.6627V13.6575V13.6524V13.6473V13.6421V13.637V13.6319V13.6268V13.6216V13.6164V13.6113V13.6061V13.601V13.5959V13.5908V13.5856V13.5805V13.5754V13.5702V13.5651V13.56V13.5548V13.5496V13.5445V13.5394V13.5342V13.5291V13.524V13.5189V13.5137V13.5086V13.5035V13.4983V13.4931V13.488V13.4829V13.4777V13.4726V13.4675V13.4623V13.4572V13.4521V13.447V13.4418V13.4367V13.4315V13.4263V13.4212V13.4161V13.411V13.4058V13.4007V13.3956V13.3904V13.3853V13.3802V13.3751V13.3698V13.3647V13.3596V13.3544V13.3493V13.3442V13.3391V13.3339V13.3288V13.3237V13.3185V13.3134V13.3082V13.3031V13.2979V13.2928V13.2877V13.2825V13.2774V13.2723V13.2672V13.262V13.2569V13.2518V13.2465V13.2414V13.2363V13.2312V13.226V13.2209V13.2158V13.2106V13.2055V13.2004V13.1953V13.1901V13.1849V13.1798V13.1746V13.1695V13.1644V13.1593V13.1541V13.149V13.1439V13.1387V13.1336V13.1285V13.1233V13.1181V13.113V13.1079V13.1027V13.0976V13.0925V13.0873V13.0822V13.0771V13.072V13.0668V13.0616V13.0565V13.0513V13.0462V13.0411V13.036V13.0308V13.0257V13.0206V13.0154V13.0103V13.0052V13V12.9948V12.9897V12.9846V12.9794V12.9743V12.9692V12.9641V12.9589V12.9538V12.9487V12.9435V12.9383V12.9332V12.9281V12.9229V12.9178V12.9127V12.9075V12.9024V12.8973V12.8922V12.887V12.8819V12.8767V12.8715V12.8664V12.8613V12.8562V12.851V12.8459V12.8408V12.8356V12.8305V12.8254V12.8203V12.815V12.8099V12.8048V12.7996V12.7945V12.7894V12.7843V12.7791V12.774V12.7689V12.7637V12.7586V12.7534V12.7483V12.7431V12.738V12.7329V12.7277V12.7226V12.7175V12.7124V12.7072V12.7021V12.697V12.6917V12.6866V12.6815V12.6764V12.6712V12.6661V12.661V12.6558V12.6507V12.6456V12.6405V12.6353V12.6301C16 12.2775 15.7511 11.9739 15.4054 11.9048L12.1176 11.2473C11.8751 11.1987 11.6244 11.2747 11.4495 11.4495L9.70075 13.1983C9.08651 12.844 8.5381 12.4235 8.05731 11.9427C7.57651 11.4619 7.15596 10.9135 6.80168 10.2992L8.55046 8.55047C8.72534 8.37557 8.80125 8.12486 8.75275 7.88232L8.09522 4.59465C8.02606 4.24888 7.72247 4 7.36986 4H4.73972Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="profileInfoText">
              +{userInfo.countryCallingCode || ""} {userInfo.phoneNumber || ""}
            </span>
          </div>

          <div className="profileInfoRow">
            <div className="profileInfoIcon">
              <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3.30518 5.50152C3 6.08978 3 6.85986 3 8.40001V10.6C3 12.1401 3 12.9103 3.30518 13.4985C3.57363 14.016 4.00198 14.4366 4.52882 14.7003C5.12778 15 5.91186 15 7.48 15H12.5201C14.0881 15 14.8723 15 15.4712 14.7003C15.9981 14.4366 16.4264 14.016 16.6949 13.4985C17 12.9103 17 12.1401 17 10.6V8.40001C17 6.85986 17 6.08978 16.6949 5.50152C16.4264 4.98408 15.9981 4.56338 15.4712 4.29973C14.8723 4 14.0881 4 12.5201 4H7.48C5.91186 4 5.12778 4 4.52882 4.29973C4.00198 4.56338 3.57363 4.98408 3.30518 5.50152ZM6.0913 6.32114C5.85005 6.16318 5.5241 6.2272 5.36326 6.46416C5.20242 6.7011 5.26762 7.02124 5.50887 7.17919L9.70888 9.9292C9.88522 10.0447 10.115 10.0447 10.2913 9.9292L14.4913 7.17919C14.7326 7.02124 14.7977 6.7011 14.637 6.46416C14.4761 6.2272 14.1502 6.16318 13.9089 6.32114L10.0001 8.88047L6.0913 6.32114Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="profileInfoText">{userInfo.email || "-"}</span>
          </div>

          <div className="profileInfoRow">
            <div className="profileInfoIcon">
              <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.1538 4.87805C12.7486 4.87805 13.2308 5.33669 13.2308 5.90244C13.2308 6.46798 12.749 6.92648 12.1546 6.92684H10.6203L11.0257 5.64156C11.1686 5.18839 11.6071 4.87805 12.1044 4.87805H12.1538ZM14.1538 5.90244C14.1538 6.27961 14.0385 6.63114 13.8394 6.92684H14.923C15.5179 6.92684 16 7.38547 16 7.95122V9.12195C16 9.68772 15.5179 10.1463 14.923 10.1463H14.7693V14.3903C14.7693 15.2793 14.0116 16 13.0769 16H10.0009C10.0006 16 10.0012 16 10.0009 16C10.0006 16 9.99939 16 9.99909 16H6.92308C5.98844 16 5.23077 15.2793 5.23077 14.3903V10.1463H5.07693C4.48216 10.1463 4 9.68772 4 9.12196V7.95122C4 7.38547 4.48215 6.92684 5.07693 6.92684H6.16056C5.96154 6.63114 5.84615 6.27961 5.84615 5.90244C5.84615 4.85175 6.74158 4 7.84616 4H7.89552C8.80054 4 9.59842 4.56468 9.85846 5.38925L10 5.838L10.1415 5.38925C10.4016 4.56468 11.1995 4 12.1044 4H12.1538C13.2585 4 14.1538 4.85175 14.1538 5.90244ZM6.15384 10.1463V14.3903C6.15384 14.7943 6.49824 15.122 6.92308 15.122H9.53846V10.1463H6.15384ZM10.4615 10.1463V15.122H13.0769C13.5018 15.122 13.8462 14.7943 13.8462 14.3903V10.1463H10.4615ZM9.37967 6.92684L8.97432 5.64156C8.8314 5.18839 8.3929 4.87805 7.89552 4.87805H7.84616C7.25138 4.87805 6.76923 5.33669 6.76923 5.90244C6.76923 6.46798 7.25101 6.92648 7.84546 6.92684H9.37967Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="profileInfoText">
              {userInfo.dateOfBirth
                ? `${new Date(userInfo.dateOfBirth).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )} (${
                    new Date().getFullYear() -
                    new Date(userInfo.dateOfBirth).getFullYear()
                  } years old)`
                : "-"}
            </span>
          </div>

          <div className="profileInfoRow">
            <div className="profileInfoIcon">
              <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.2626 4.22325C7.13522 4.08138 6.95121 4 6.75776 4C6.56433 4 6.38031 4.08138 6.25293 4.22325L4.16598 6.54774C3.92203 6.81946 3.95027 7.23249 4.22908 7.47025C4.5079 7.70801 4.93169 7.68047 5.17564 7.40874L6.08696 6.39372V10.6635C4.92966 10.9538 4.07454 11.9776 4.07454 13.1962C4.07454 14.6404 5.27586 15.8112 6.75776 15.8112C8.23967 15.8112 9.44099 14.6404 9.44099 13.1962C9.44099 11.9776 8.58586 10.9538 7.42857 10.6635V6.39372L8.33988 7.40874C8.58385 7.68047 9.00764 7.70801 9.28644 7.47025C9.56525 7.23249 9.59351 6.81946 9.34955 6.54774L7.2626 4.22325ZM8.09937 13.1962C8.09937 13.9183 7.49872 14.5037 6.75776 14.5037C6.01682 14.5037 5.41615 13.9183 5.41615 13.1962C5.41615 12.474 6.01682 11.8886 6.75776 11.8886C7.49872 11.8886 8.09937 12.474 8.09937 13.1962ZM13.3168 8.11132C14.0577 8.11132 14.6584 7.52592 14.6584 6.8038C14.6584 6.08167 14.0577 5.49628 13.3168 5.49628C12.5758 5.49628 11.9752 6.08167 11.9752 6.8038C11.9752 7.52592 12.5758 8.11132 13.3168 8.11132ZM16 6.8038C16 8.0223 15.1449 9.04615 13.9876 9.33645V10.799H15.1056C15.4761 10.799 15.7764 11.0917 15.7764 11.4528C15.7764 11.8138 15.4761 12.1065 15.1056 12.1065H13.9876V15.3462C13.9876 15.7073 13.6872 16 13.3168 16C12.9463 16 12.646 15.7073 12.646 15.3462V12.1065H11.5279C11.1575 12.1065 10.8571 11.8138 10.8571 11.4528C10.8571 11.0917 11.1575 10.799 11.5279 10.799H12.646V9.33645C11.4887 9.04615 10.6335 8.0223 10.6335 6.8038C10.6335 5.35954 11.8348 4.18875 13.3168 4.18875C14.7986 4.18875 16 5.35954 16 6.8038Z"
                  fill="white"
                />
              </svg>
            </div>
            <span className="profileInfoText">{userInfo.gender || "-"}</span>
          </div>

          <div className="profileInfoRow">
            <div className="profileInfoIcon">
              <svg
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 14L14.5627 12.5055C14.5152 12.4514 14.4554 12.4154 14.391 12.4018C14.3265 12.3882 14.2601 12.3977 14.2001 12.4291C14.1401 12.4605 14.0891 12.5124 14.0535 12.5783C14.0179 12.6443 13.9993 12.7213 14 12.7999V13.1999C14 13.4121 13.9298 13.6156 13.8047 13.7657C13.6797 13.9157 13.5101 14 13.3333 14H12C11.8232 14 11.6536 13.9157 11.5286 13.7657C11.4036 13.6156 11.3333 13.4121 11.3333 13.1999C11.3333 11.1638 8.67267 10.0237 5.66667 9.99968C5.22464 9.99968 4.80072 10.2104 4.48816 10.5855C4.17559 10.9606 4 11.4694 4 11.9998C4 12.5303 4.17559 13.0391 4.48816 13.4142C4.80072 13.7893 5.22464 14 5.66667 14C8.43533 14 8.83 4.96327 9.472 3.19913C9.58045 2.90134 9.74773 2.63975 9.95937 2.437C10.171 2.23424 10.4206 2.09643 10.6866 2.03549C10.9526 1.97454 11.227 1.9923 11.486 2.08722C11.745 2.18214 11.9808 2.35137 12.173 2.58027C12.3653 2.80916 12.5081 3.09082 12.5893 3.40088C12.6704 3.71094 12.6874 4.04006 12.6387 4.35975C12.59 4.67944 12.4771 4.98009 12.3099 5.23566C12.1426 5.49124 11.9259 5.69405 11.6787 5.82654"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4 17H16"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <span className="profileInfoText">
              {userInfo.pdpa === "1" ? "Consented" : ""}
            </span>
          </div>
        </div>

        {/* Rewards Section */}
        <div className="profileRewardsSection">
          <h3>Rewards</h3>

          {userInfo.campaignBalances && userInfo.campaignBalances.length > 0 ? (
            userInfo.campaignBalances.map((campaign, index) => {
              // Determine the value to display based on campaign type
              let value = "";
              let valueLabel = "";

              switch (campaign.campaignType) {
                case "loyalty":
                  value = campaign.points;
                  valueLabel = "Points";
                  break;
                case "cashback":
                  value = `$${(campaign.amounts || 0).toFixed(2)}`;
                  valueLabel = "Cashback";
                  break;
                case "voucher":
                  value = campaign.vouchers;
                  valueLabel = "Vouchers";
                  break;
                case "stamps":
                  value = campaign.stamps;
                  valueLabel = "Stamps";
                  break;
                case "stored-value":
                  value = `$${(campaign.values || 0).toFixed(2)}`;
                  valueLabel = "Stored Value";
                  break;
                default:
                  return null; // Skip unknown campaign types
              }

              // Skip campaigns with 0 or falsy values
              if (!value) return null;

              return (
                <div
                  key={campaign.campaignId || index}
                  className="profileRewardCard"
                >
                  <div className="profileRewardHeader">
                    <span className="profileRewardTitle">{campaign.name}</span>
                    <span className="profileRewardValue">
                      {value} {valueLabel}
                    </span>
                  </div>
                  <div className="profileRewardBottom">
                    <div
                      className={`profileRewardBadge ${campaign.campaignType}`}
                    >
                      <span>{valueLabel}</span>
                    </div>
                    <div className="profileRewardExpiry">
                      {campaign.expireDate ? (
                        <>
                          <span className="label">Expiry:</span>
                          <span className="date">
                            {new Date(campaign.expireDate).toLocaleDateString()}
                          </span>
                        </>
                      ) : (
                        <span className="date">Never Expires</span>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="noRewards">No rewards available</div>
          )}
        </div>
      </div>
    </Modal>
  );
});

// Reward component is defined but not used in this file
// const Reward = observer(
//   ({ index, item, onSelectFunction, selectedRewards, isValidFound }) => {
const _Reward = observer(
  ({ index, item, onSelectFunction, selectedRewards, isValidFound }) => {
    let found = false;
    const rewardImage =
      item.image_url && item.image_url !== ""
        ? item.image_url
        : configParam.rewardImage;

    if (selectedRewards && selectedRewards.length > 0) {
      selectedRewards.forEach((val) => {
        if (val.campaignId === item.campaignId) {
          found = true;
        }
      });
    }

    return (
      <div
        className={isValidFound ? "rewardPoints disableReward" : "rewardPoints"}
        key={`reward-${index}`}
        onClick={() => onSelectFunction(item)}
      >
        <div
          className="rewardGiftIcon"
          style={{ backgroundImage: `url(${rewardImage})` }}
        ></div>
        <div
          className={found ? "rewardWhiteBox activeRwBox" : "rewardWhiteBox"}
        >
          <p className="rwrdAmtCenterText">{item.name}</p>
          {item.points && (
            <p className="rwrdAmtCenterText">{item.points} Points</p>
          )}
          {found && <p className="removereward">Remove</p>}
        </div>
      </div>
    );
  }
);

const RewardItemList = observer(
  ({ visible, cartStore, selectedReward, onPressFunction, menuToDisplay }) => {
    const rewardName = cartStore.checkRewardItemInCart();

    return (
      <Modal
        visible={visible}
        style={{ overflow: "hidden", height: "100%", textAlign: "center" }}
        className="profileDrawer"
      >
        <div className="info_header">
          <span
            className="backBtn"
            onClick={() => {
              onPressFunction();
            }}
          ></span>
          <span className="logoclass">
            <img
              src={cartStore.menuStore.getLogo()}
              alt="logo"
              style={{ height: "40px" }}
            />
          </span>
          <span className="homeclass"></span>
        </div>
        <div className="fixedMenuSection">
          <div className="mainMenuContainer rewardMenuContainer">
            <div style={{ color: "black", fontWeight: "700" }}>
              {selectedReward.name}
            </div>
            <div
              style={{ color: "black", fontWeight: "500", fontSize: "13px" }}
            >
              Select eligible item for reward
            </div>
            {Object.keys(menuToDisplay).map((key, index) => (
              <RewardMenuEntry
                header={key}
                items={menuToDisplay[key]}
                cartStore={cartStore}
                key={`rewardItem${index}`}
                selectedReward={selectedReward}
                rewardName={rewardName}
              />
            ))}
            {menuToDisplay.length === 0 && <div>Items not found</div>}
          </div>
        </div>
        <div className="continueWithRwContainer" style={{ paddingTop: "15px" }}>
          <div className="continueWithRw formSection">
            <p
              style={{
                marginBottom: "0",
                paddingLeft: "15px",
                fontSize: "12px",
                fontWeight: "700",
              }}
              onClick={() => {
                cartStore.menuStore.isRewardModalVisible = false;
              }}
            >
              Continue <i className="continueWithRwArrow"></i>
            </p>
          </div>
        </div>
      </Modal>
    );
  }
);

const RewardMenuEntry = observer(
  ({ header, items, cartStore, selectedReward, rewardName }) => {
    return (
      <div id={header} className="gridItemBox itemCatList">
        <div className="">
          <div className="menuHeader" style={{ textAlign: "left" }}>
            {header}
          </div>
          <section className={"gridContainer listvw"}>
            {items.map((item, index) => (
              <div
                className="menuItemsFlex rewardItemsFlex"
                key={index + "-relist"}
              >
                <RewardItemListEntry
                  key={index}
                  item={item}
                  cartStore={cartStore}
                  selectedReward={selectedReward}
                  rewardName={rewardName}
                />
              </div>
            ))}
          </section>
        </div>
      </div>
    );
  }
);
const RewardItemListEntry = observer(
  ({ item, cartStore, selectedReward, rewardName }) => {
    let avail = cartStore.menuStore.isAvailable(item);
    let amt = 0;
    if (item.hasAddons) {
      amt = cartStore.getLeastAddonPrice([item.addons]);
    }
    let priceTx = item.displayPrice;
    if (parseFloat(item.price) === 0) {
      priceTx =
        "From " +
        cartStore.menuStore.currencySymbol +
        parseFloat(amt).toFixed(2);
    } else {
      let { actualPrice, priceAmt } = cartStore.calculateRewardDiscoutPrice(
        selectedReward,
        item.price
      );
      if (actualPrice !== priceAmt) {
        priceTx = (
          <Fragment>
            <strike className="strikeprice">
              {cartStore.menuStore.currencySymbol +
                parseFloat(actualPrice).toFixed(2)}
            </strike>
            {cartStore.menuStore.currencySymbol +
              parseFloat(priceAmt).toFixed(2)}
          </Fragment>
        );
      }
    }
    let infoItem = item.name.includes("#INFO#");
    let name = item.name.replace("#INFO#", "");
    let qty = cartStore.getRewardItemQty(item);
    const chef1 = item.chef1 || 0;
    let parentCls =
      item.promoName.replace(/ /g, "-").toLowerCase() + " itemslist";
    if (chef1 === 1) {
      parentCls = parentCls + " parentChef";
    }
    return (
      <div
        style={{
          display: "flex",
          paddingBottom: 15,
          position: "relative",
          width: "100%",
        }}
        className={parentCls}
        key={item.id}
        id={item.id}
      >
        <div
          style={{
            paddingRight: 6,
            position: "relative",
          }}
          className="customList"
        >
          {chef1 === 1 ? <span className="chefRecommended"></span> : null}
          <div
            className="thumbnailPlaceholder"
            style={{ borderRadius: "20px" }}
          />
          <img
            className="listEntryImage imageLoaded rwImageRadius"
            src={item.thumbnail}
            alt=""
          />
        </div>

        <div
          className="li-text"
          style={{ paddingLeft: "15px", textAlign: "left" }}
        >
          <h4
            className="li-head max-lines"
            style={{ color: "black", fontWeight: "800" }}
            dangerouslySetInnerHTML={{
              __html: cartStore.menuStore.htmlDecode(name),
            }}
          />
          {rewardName}
          <div
            className="max-lines"
            style={{ minHeight: "2.8em" }}
            dangerouslySetInnerHTML={{
              __html: cartStore.menuStore.htmlDecode(item.description),
            }}
          />
          <div
            className="priceDetails"
            style={{ display: "flex", paddingTop: "25px" }}
          >
            <p className="li-sub" style={{ paddingTop: 3 }}>
              <span className="itemPrice">sad21dasd{priceTx}</span>
            </p>

            {!item.isInStock && (
              <div>
                <span
                  style={{
                    display: "block",
                    color: "gray",
                    fontSize: 12,
                    paddingTop: 9,
                    width: 138,
                    textAlign: "center",
                  }}
                >
                  {cartStore.menuStore.translation.out_of_stock}
                </span>
              </div>
            )}
            {!avail && item.isInStock && (
              <div>
                <span
                  style={{
                    display: "block",
                    color: "gray",
                    fontSize: 12,
                    paddingTop: 9,
                    width: 138,
                    textAlign: "center",
                  }}
                >
                  {cartStore.menuStore.translation.not_available_now}
                </span>
              </div>
            )}
            {item.isInStock && avail && !infoItem ? (
              <div>
                {qty > 0 ? (
                  <div>
                    <div className={"food-stepper-container single"}>
                      <span
                        onClick={() => {
                          cartStore.removeItem(item);
                        }}
                        className="food-stepper-select tick rewardMenuList"
                      ></span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className={"food-stepper-container single"}>
                      <span
                        onClick={() => {
                          //manageItemInfo(item,cartStore);
                          // Thay vì hiển thị popup, hiển thị trực tiếp nội dung item info
                          cartStore.menuStore.itemModal.setItem(
                            item,
                            selectedReward
                          );
                          // Mở trực tiếp modal addon thay vì popup item info
                          cartStore.menuStore.openSetModal = true;
                        }}
                        className="food-stepper-select plus rewardMenuList"
                      ></span>
                    </div>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
);
function checkQuanityError(cartStore, item, qty) {
  let qty1 = qty;
  let isNextproceed = true;
  if (qty < 0) {
    let enty = cartStore.getEntry(item);
    qty1 = 1;
    if (enty) {
      qty = Math.abs(qty);
      let oldQty = cartStore.quantity_map.get(item.id);
      //// console.log(qty,'<',oldQty);
      if (qty < oldQty) {
        qty1 = 0;
        isNextproceed = false;
      }
    }
  }
  if (!isNextproceed) {
    return true;
  }
  let erroMsg = cartStore.checkQuantityValidation(item, qty1);
  if (erroMsg !== "") {
    alert(cartStore.menuStore.translation.error, erroMsg, [
      { text: "Close", onPress: () => {} },
    ]);
    return false;
  }
  return true;
}
function specialRequest(cartStore, item, qty, isSingleQty) {
  let errFound = checkQuanityError(cartStore, item, qty);
  if (qty < 0) {
    qty = Math.abs(qty);
  }
  if (!errFound) {
    return false;
  } else if (item.hasAddons) {
    manageItemInfo(item, cartStore);
  } else if (cartStore.menuStore.layout === 4) {
    cartStore.menuStore.itemModal.setItem(item, {});
    cartStore.menuStore.openSetModal = true;
  } else {
    let cQty = cartStore.quantity_map.get(item.id);
    // console.log(isSingleQty,cQty,qty);
    let starCnt = item.opt1.split("*");
    if (
      item.opt1 !== "" &&
      cartStore.menuStore.auto_modifier.toString() === "1" &&
      starCnt.length === 1 &&
      ((qty > cQty && isSingleQty === 0) || isSingleQty === 1)
    ) {
      let priceTx =
        parseFloat(item.price) === 0
          ? cartStore.menuStore.translation.price_zero
          : item.displayPrice;
      if (!priceTx || priceTx.trim() === "") {
        priceTx = "";
      }
      let name = item.name.replace("#INFO#", "");
      let item_popup_name = _renderName(
        cartStore.menuStore.htmlDecode(name),
        cartStore.menuStore.htmlDecode(priceTx)
      );
      let optList = [];
      let optSelList = [];
      let footerbtn = [];
      let options = item.opt1.split(",");
      let singleSelection = false;
      if (options.length > 0) {
        options[0] = options[0].replace("*", "").trim();
        if (options[options.length - 1].trim() !== "") {
          singleSelection = true;
        }
        let k = 0;
        options.forEach(function (val) {
          val = val.trim();
          //let namStr = val.replace(EXP_TRIM, "");
          if (val !== "") {
            k++;
            let idstr = "optMenu" + item.id + k;
            optList.push(
              <div
                className="optselection"
                key={val}
                id={idstr}
                onClick={(l) => {
                  let element = document.querySelector("#" + idstr);
                  let cls = "selectedOpt";
                  //	let arr = element.className.split(" ");
                  if (optSelList.indexOf(val) === -1) {
                    if (singleSelection && optSelList.length > 0) {
                      optSelList = [];
                      let oldone = document.querySelector(".selectedOpt");
                      oldone.className = oldone.className.replace(
                        " selectedOpt",
                        ""
                      );
                    }
                    element.className += " " + cls;
                    optSelList.push(val);
                  } else {
                    optSelList.splice(optSelList.indexOf(val), 1);
                    element.className = element.className.replace(
                      " selectedOpt",
                      ""
                    );
                  }
                }}
              >
                {val}
              </div>
            );
          }
        });

        footerbtn.push({
          text: cartStore.menuStore.translation.more,
          onPress: () => {
            //cartStore.menuStore.item_popup_name="";
            cartStore.menuStore.itemModal.setMultiChoiceWithFooter(
              false,
              [],
              [],
              ""
            );
            cartStore.menuStore.itemModal.setItem(item, {});
          },
        });
        footerbtn.push({
          text: cartStore.menuStore.translation.add,
          onPress: () => {
            //cartStore.menuStore.item_popup_name="";
            let obj = {};
            obj.item = item;
            obj.addons = null;
            obj.notes = [optSelList.join(";")];
            cartStore.addItem(obj);
            //cartStore.addItemFromMenu(item, 1);
            cartStore.menuStore.sendGoogleAnalytics(
              cartStore.menuStore.googleAddItem,
              item.name,
              cartStore.menuStore.controller,
              item.price * 1 * 100
            );
            cartStore.menuStore.itemModal.setMultiChoiceWithFooter(
              false,
              [],
              [],
              ""
            );
          },
        });

        //  cartStore.menuStore.itemModal.setMultiChoice(true,optList);
        cartStore.menuStore.itemModal.setMultiChoiceWithFooter(
          true,
          optList,
          footerbtn,
          item_popup_name
        );
      }
    } else {
      if (isSingleQty === 1) {
        let obj = {};
        obj.item = item;
        obj.addons = null;
        obj.notes = [""];
        cartStore.addItem(obj);
      } else {
        cartStore.addItemFromMenu(item, qty);
      }

      // cartStore.menuStore.sendGoogleAnalytics(cartStore.menuStore.googleAddItem, item.name,cartStore.menuStore.controller,item.price*1);
    }

    //}
  }
}
function _renderName(name, priceTx) {
  return (
    <div>
      <span
        className="max-lines fontboldstyle"
        style={{ minHeight: "2.8em" }}
        dangerouslySetInnerHTML={{ __html: name }}
      />
      <p className="li-sub" style={{ paddingTop: 3 }}>
        zxcxzcxz
        <span
          className="itemPrice"
          dangerouslySetInnerHTML={{ __html: priceTx }}
        />
      </p>
    </div>
  );
}
function _appendQty(qty, name) {
  if (qty > 0) {
    return '<span class="qtyc">' + qty + "x " + name + "</span>";
  }
  return name;
}
function manageItemInfo(item, cartStore) {
  if (item.isCustomize) {
    let enty = cartStore.getEntry(item);
    if (enty) {
      cartStore.menuStore.itemModal.showUpdateModal(
        enty.item,
        enty.addons,
        enty.notes
      );
      return false;
    }
  }
  cartStore.menuStore.itemModal.setItem(item, {});
}
export { Menu, RewardItemList, RewardList };
